import _slicedToArray from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray"; //@ts-check

import React from 'react';
import Grid from '@material-ui/core/Grid';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';

function tabProps(index) {
  return {
    id: "synchronization-tab-".concat(index),
    'aria-controls': "synchronization-tabpanel-".concat(index)
  };
}

function TabPanel(props) {
  var children = props.children,
      crmType = props.crmType,
      field = props.field;
  var type = '';
  if (crmType === 'salesforce') type = 'Salesforce';else if (crmType === 'dynamics') type = 'Microsoft Dynamics';else if (crmType === 'bpmonline') type = 'BPM Online';
  return React.createElement("div", {
    role: "tabpanel",
    id: "synchronization-tabpanel-".concat(field),
    "aria-labelledby": "synchronization-tab-".concat(field)
  }, React.createElement(Grid, {
    container: true,
    style: {
      paddingTop: '16px'
    }
  }, React.createElement(Grid, {
    item: true,
    sm: 5,
    xs: 5
  }, "Engage ".concat(field)), React.createElement(Grid, {
    item: true,
    sm: 1,
    xs: 1
  }), React.createElement(Grid, {
    item: true,
    sm: 5,
    xs: 5
  }, "".concat(type, " ").concat(field)), React.createElement(Grid, {
    item: true,
    sm: 1,
    xs: 1
  })), children);
}

var FormTabs = function FormTabs(_ref) {
  var options = _ref.options,
      crmType = _ref.crmType,
      children = _ref.children;

  var _React$useState = React.useState(0),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      crtTabIdx = _React$useState2[0],
      handleTabChange = _React$useState2[1];

  return React.createElement(React.Fragment, null, React.createElement(Tabs, {
    value: crtTabIdx,
    onChange: function onChange(e, v) {
      return handleTabChange(v);
    },
    "aria-label": "Synchronization Mappings"
  }, options.map(function (o, idx) {
    return React.createElement(Tab, Object.assign({
      key: o.value,
      label: o.label
    }, tabProps(idx)));
  })), React.createElement(TabPanel, {
    key: options[crtTabIdx].value,
    field: options[crtTabIdx].label,
    crmType: crmType
  }, children(options[crtTabIdx])));
};

export default FormTabs;